import axios from '@/common/axios'

export function fetchPageMeta() {
  return axios.get('/api/reviews_dashboard/page_meta')
}

export function getReviews(params = {}) {
  return axios.get('/api/reviews_dashboard', { params })
}

export function getStats(params = {}) {
  return axios.get('/api/reviews_dashboard/stats', { params })
}

export function exportReviewsCsv(params = {}) {
  return axios.get('/api/reviews_dashboard/csv_export', { params, responseType: 'blob' })
}

export function submitApprovalReply(locationRemoteId, reviewRemoteId, comment) {
  return axios.patch(`/api/gmb/locations/${locationRemoteId}/reviews/${reviewRemoteId}`, {
    gmbReview: { reviewReply: { comment } }
  })
}
